import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import { PrintButton } from 'web-ui-components/lib/documents/printing';
import { LeftAndRightAlignment } from 'web-ui-components/lib/global/layout';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint-disable class-methods-use-this*/

var PrintHelperWebUI = function (_Component) {
  inherits(PrintHelperWebUI, _Component);

  function PrintHelperWebUI(props) {
    classCallCheck(this, PrintHelperWebUI);

    var _this = possibleConstructorReturn(this, (PrintHelperWebUI.__proto__ || Object.getPrototypeOf(PrintHelperWebUI)).call(this, props));

    _this.onPrintClick = _this.onPrintClick.bind(_this);
    return _this;
  }

  createClass(PrintHelperWebUI, [{
    key: 'onPrintClick',
    value: function onPrintClick() {
      window.print();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          showPrintTopIcon = _props.showPrintTopIcon,
          showPrintBottomIcon = _props.showPrintBottomIcon,
          brandId = _props.brandId;

      var brand = brandId.toUpperCase() === 'DYB' ? 'B' : brandId;
      var PrintTopButton = React.createElement(PrintButton.Top, { onClick: this.onPrintClick });
      var PrintBottomButton = React.createElement(PrintButton.Bottom, { onClick: this.onPrintClick });
      return React.createElement(
        WebUIThemeProvider,
        { brandID: brand },
        React.createElement(
          'div',
          null,
          showPrintTopIcon && React.createElement(
            'div',
            { className: className },
            React.createElement(
              'div',
              { className: 'noprint' },
              React.createElement(LeftAndRightAlignment, { rightNode: PrintTopButton })
            )
          ),
          children,
          showPrintBottomIcon && React.createElement(
            'div',
            { className: className },
            React.createElement(
              'div',
              { className: 'noprint' },
              React.createElement(LeftAndRightAlignment, { rightNode: PrintBottomButton })
            )
          )
        )
      );
    }
  }]);
  return PrintHelperWebUI;
}(Component);

PrintHelperWebUI.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  showPrintTopIcon: PropTypes.bool,
  showPrintBottomIcon: PropTypes.bool,
  brandId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
};

PrintHelperWebUI.defaultProps = {
  brandId: 'CB'
};

export default PrintHelperWebUI;
